var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'rounded-full px-4 py-1 text-xs ' + this.computedVariant,on:{"click":function($event){return _vm.$emit('click', $event.target.value)}}},[_vm._v(_vm._s(this.label))])}
var staticRenderFns = []

export { render, staticRenderFns }